import { __ } from "@wordpress/i18n";
import Tagify from "@yaireo/tagify";
import "@yaireo/tagify/dist/tagify.css";
import React, { useEffect, useRef, useState } from "react";
import "./TagInput.scss";

const TagInput = ({ whitelist = [], handleChange, disabled = false }) => {
    const tagifyInputRef = useRef(null);
    const tagifyInstanceRef = useRef(null);
    
    useEffect(() => {
        // Ensure whitelist is an array before trying to map it
        const safeWhitelist = Array.isArray(whitelist) ? whitelist : [];
        
        // Format whitelist for Tagify
        const formattedWhitelist = safeWhitelist.map(item => ({
            value: item.value || '',
            label: item.label || item.value || ''
        }));
        
        // Initialize Tagify with enabled dropdown
        tagifyInstanceRef.current = new Tagify(tagifyInputRef.current, {
            whitelist: formattedWhitelist,
            dropdown: {
                maxItems: formattedWhitelist.length,
                enabled: 1,
                position: "text",
                closeOnSelect: false,
                highlightFirst: true,
                searchKeys: ["value", "label"]
            },
            enforceWhitelist: true, // Only allow items from whitelist
            readonly: disabled
        });

        // Listen for tag changes
        tagifyInstanceRef.current.on("change", (e) => {
            let parsedTags;
            try {
                parsedTags = JSON.parse(e.detail.value);
            } catch (error) {
                parsedTags = [];
            }
            
            // Extract just the values for the parent component
            const tagValues = parsedTags.map(tag => 
                typeof tag === 'object' && tag.value ? tag.value : tag
            );
            
            if (handleChange) {
                handleChange(tagValues);
            }
        });

        return () => {
            if (tagifyInstanceRef.current) {
                tagifyInstanceRef.current.destroy();
            }
        };
    }, [whitelist, disabled]);

    // Handle Select All
    const handleSelectAll = () => {
        if (disabled || !tagifyInstanceRef.current) return;
        
        tagifyInstanceRef.current.removeAllTags();
        
        const tagsToAdd = whitelist.map(item => item.value);
        tagifyInstanceRef.current.addTags(tagsToAdd);
    };

    // Handle Remove All
    const handleRemoveAll = () => {
        if (disabled || !tagifyInstanceRef.current) return;
        
        tagifyInstanceRef.current.removeAllTags();
        
        if (handleChange) {
            handleChange([]);
        }
    };

    return (
        <div className="tagify-wrapper">
            <input 
                type="text" 
                ref={tagifyInputRef} 
                placeholder={disabled ? "" : "Add roles..."}
                disabled={disabled}
            />     
        </div>
    );
};

export default TagInput;